import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "../../../../hooks/useAuth";
import { roleRoutes } from "../../../../utils/roles";
import { holdingApiCredentials } from "../../../../api/operatorHoldings";
import ApiCredentialsSection from "../../../clientView/integrations/apiCredentials/ApiCredentialsSection";

// Mismos roles que crean y vinculan empresas: los que deja pasar OperatorAdminGuard de
// integrations. La autoridad es el backend; esto evita ofrecer una pantalla que da 403.
const MANAGE_ROLE_IDS = new Set([roleRoutes.admin, roleRoutes.superadmin]);

/**
 * Credenciales de la API de holdings (scope `companies:write`): con ellas el sistema del
 * holding crea sus empresas por API, con el contrato del holding replicado. Reusa la sección
 * de credenciales del comercio con las llamadas de holding.
 *
 * @param {{ holding: object }} props  elemento de GET contracts/holdings.
 */
export default function HoldingApiCredentialsSection({ holding }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  // Memoizado: la sección recarga cada vez que cambia `api`.
  const api = useMemo(() => holdingApiCredentials(holding.id), [holding.id]);

  if (!MANAGE_ROLE_IDS.has(user?.role)) {
    return (
      <p className="text-sm text-fg-muted">
        {t("Solo un administrador o un superadministrador logístico puede administrar las credenciales de API del holding.")}
      </p>
    );
  }

  return (
    <ApiCredentialsSection
      api={api}
      embedded
      intro={t("El sistema del holding usa estas credenciales para crear empresas por API (POST /integrations/public-api/companies). Cada empresa nace con el contrato del holding. Entrégale el secreto solo al holding y revócalo si se filtra.")}
    />
  );
}
